import {Component, Input, OnInit} from '@angular/core';
import {GSEUploadError, GSEUploadResponse} from 'smag-commons/dto/api/massive-upload';
import {GseErrorCode, mkBaseError} from '../../../api/errors';
import {I18NService} from '../../../i18n/i18n.service';

@Component({
    selector: 'app-gse-errors',
    templateUrl: './gse-errors.component.html',
    styleUrls: ['./gse-errors.component.scss']
})
export class GseErrorsComponent implements OnInit {

    @Input() gseResponse: GSEUploadResponse;

    constructor(private readonly i18NService: I18NService) {
    }

    ngOnInit(): void {
    }

    mkErrorMessage(error: GSEUploadError): string {
        switch (error.code) {
            case GseErrorCode.UNKNOWN_POD_FOR_COMMUNITY:
                return this.i18NService.translate('{0}: does not belong to the community', mkBaseError(error, this.i18NService));
            case GseErrorCode.BAD_POD_TYPE_FOR_COMMUNITY:
                return this.i18NService.translate('{0}: has bad type', mkBaseError(error, this.i18NService));
            case GseErrorCode.MISSING_POD_ABSORPTION_DATA:
                return this.i18NService.translate('{0}: has missing absorption data', mkBaseError(error, this.i18NService));
            case GseErrorCode.MISSING_POD_INJECTION_DATA:
                return this.i18NService.translate('{0}: has missing injection data', mkBaseError(error, this.i18NService));
            default:
                return this.i18NService.translate('An error occurred while uploading data');
        }
    }

}




